/* eslint-disable jsx-a11y/media-has-caption */
import React, {useMemo} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {imageTransform} from '../cms-picture/buttercms-image-transform'

const propTypes = {
  poster: PropTypes.string,
}
const defaultProps = {
  poster: undefined,
}

export type CmsVideoProps = InferPropTypes<typeof propTypes, typeof defaultProps> &
  React.ComponentProps<'video'>

const CmsVideo: React.FC<CmsVideoProps> = ({poster, ...restProps}) => {
  const optimizedPoster = useMemo(() => {
    if (poster) {
      return imageTransform(poster, {
        mobile: false,
        optimize: true,
        disableResize: true,
      })
    }
    return undefined
  }, [poster])

  return <video poster={optimizedPoster ?? undefined} {...restProps} />
}

CmsVideo.propTypes = propTypes
CmsVideo.defaultProps = defaultProps

export default CmsVideo
